module.exports = __webpack_public_path__ + "static/media/createCustomTaskHover.4c80aa7d.png";